(() => {
  if (window.BPLipLabAPI) { window.BPLipLabAPI.initialize(document); return; }
  const SHADE = {
    '55059233603923': { color: '#DB9183', family: 'nude' },
    '55059233636691': { color: '#C4736C', family: 'rose' },
    '55059233669459': { color: '#C7745F', family: 'rose' },
    '55059233702227': { color: '#FA6D76', family: 'rose' },
    '55059233734995': { color: '#DE716C', family: 'terracotta' },
    '55059233767763': { color: '#D92B3C', family: 'red' },
    '52561477108051': { color: '#C67A79', family: 'rose' },
    '52561477140819': { color: '#CE6E66', family: 'rose' },
    // Approximate pigment median from the approved Cappuccino swatch a079eae505c5; not a calibrated measurement.
    '52561477173587': { color: '#9D6452', family: 'nude' },
    '55178027106643': { color: '#BA6A66', family: 'nude' },
    '52561477206355': { color: '#C20217', family: 'red' },
    '52561451254099': { color: '#BA6A66', family: 'nude' },
    '52561451286867': { color: '#C67A79', family: 'rose' },
    '52561451319635': { color: '#BF675C', family: 'terracotta' },
    '52561451352403': { color: '#CE6E66', family: 'rose' },
    '52561451385171': { color: '#C20217', family: 'red' },
    '47491894968659': { color: '#EAE3DE', family: 'clear' },
    '50304612991315': { color: '#E5E6E5', family: 'glitter' },
    '47491895001427': { color: '#EFE7DC', family: 'glitter' },
    '47491895034195': { color: '#E9BDCA', family: 'glitter' },
    '43634254774484': { color: '#D2A78F', family: 'clear' }
  };
  const QUESTIONS = [
    { key: 'mood', choices: ['sunset', 'star', 'daily'] },
    { key: 'family', choices: ['nude', 'rose', 'terracotta', 'red'] },
    { key: 'finish', choices: ['matte', 'gloss', 'glitter'] },
    { key: 'boldness', choices: ['natural', 'defined', 'bold'] }
  ];
  const FINISH = {
    '47491894968659': { tint: null, tintOpacity: 0, sheen: .28, glitter: 0 },
    '50304612991315': { tint: '#E5E6E5', tintOpacity: .09, sheen: .38, glitter: .74, glitterColor: '#F6F8FC' },
    '47491895001427': { tint: '#EFE7DC', tintOpacity: .10, sheen: .39, glitter: .66, glitterColor: '#FFF1D8' },
    '47491895034195': { tint: '#E9BDCA', tintOpacity: .14, sheen: .40, glitter: .73, glitterColor: '#FFD1E4' },
    '51167643238739': { tint: null, tintOpacity: 0, sheen: .46, glitter: 0 },
    '43634254774484': { tint: '#D2A78F', tintOpacity: .06, sheen: .32, glitter: 0 }
  };
  const instances = new WeakMap();
  const format = (amount, currency, language) => {
    try { return new Intl.NumberFormat(language || 'it-IT', { style: 'currency', currency: currency || 'EUR' }).format(amount / 100); }
    catch { return `${(amount / 100).toFixed(2)} ${currency || 'EUR'}`; }
  };
  const normalizedRoot = root => `${(root || '/').replace(/\/+$/, '')}/`;
  const element = (tag, className, content) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined) node.textContent = content;
    return node;
  };

  function mount(root) {
    if (instances.has(root)) return;
    const source = root.querySelector('[data-lip-catalog]');
    if (!source) return;
    let catalog;
    try { catalog = JSON.parse(source.textContent); } catch { return; }
    const labels = catalog.labels;
    const products = catalog.products || [];
    const records = products.flatMap(product => (product.variants || []).map(variant => ({
      ...variant, id: String(variant.id), product, brand: product.brand, role: product.role,
      shade: SHADE[String(variant.id)] || null
    }))).filter(record => record.available && !record.requiresSellingPlan && Number.isSafeInteger(Number(record.id)) && Number.isSafeInteger(Number(record.price)) && Number(record.price) >= 0);
    const state = { mode: 'intro', step: 0, answers: {}, brand: 'all', activeRole: null, chosen: { liner: null, base: null, finish: null }, pending: false, committed: false, request: null, destroyed: false };
    const work = root.querySelector('[data-lip-work]');
    const quiz = root.querySelector('[data-lip-quiz]');
    const reveal = root.querySelector('[data-lip-reveal]');
    const composer = root.querySelector('[data-lip-composer]');
    const resultPanel = root.querySelector('[data-lip-result]');
    const summaryPanel = root.querySelector('[data-lip-summary-panel]');
    const status = root.querySelector('[data-lip-status]');
    const total = root.querySelector('[data-lip-total]');
    const summary = root.querySelector('[data-lip-summary]');
    const add = root.querySelector('[data-lip-action="add"]');
    const reason = root.querySelector('[data-lip-reason]');
    const rendererHost = root.querySelector('[data-lip-renderer]');
    const rendererSources = ['light', 'medium', 'deep'].map(tone => rendererHost?.dataset[`lipSource${tone.charAt(0).toUpperCase()}${tone.slice(1)}`]);
    const renderer = rendererHost && window.BPLipRenderer?.mount(rendererHost, { sources: rendererSources, labels: [labels.skinLight, labels.skinMedium, labels.skinDeep] });
    const listeners = [];
    const listen = (target, type, fn) => { target.addEventListener(type, fn); listeners.push([target, type, fn]); };
    const pageHeader = document.querySelector('header.page-header');
    let stickyFrame = 0;
    const updateStickyTop = () => {
      stickyFrame = 0;
      const headerBottom = pageHeader ? pageHeader.getBoundingClientRect().bottom : 0;
      root.style.setProperty('--bp-lip-sticky-top', `${Math.ceil(Math.max(0, headerBottom) + 12)}px`);
    };
    const scheduleStickyTop = () => {
      if (!stickyFrame) stickyFrame = window.requestAnimationFrame(updateStickyTop);
    };
    const headerResize = pageHeader && 'ResizeObserver' in window ? new ResizeObserver(scheduleStickyTop) : null;
    const headerMutation = pageHeader && 'MutationObserver' in window ? new MutationObserver(scheduleStickyTop) : null;
    headerResize?.observe(pageHeader);
    headerMutation?.observe(pageHeader, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    listen(window, 'scroll', scheduleStickyTop);
    listen(window, 'resize', scheduleStickyTop);
    if (window.visualViewport) listen(window.visualViewport, 'resize', scheduleStickyTop);
    updateStickyTop();
    const setStatus = (message, error = false, cartLink = false) => {
      status.replaceChildren(); status.dataset.error = String(error);
      if (message) status.append(element('span', '', message));
      if (cartLink) { const link = element('a', '', labels.checkCart); link.href = `${normalizedRoot(catalog.root)}cart`; status.append(link); }
    };
    const selected = role => records.find(record => record.id === state.chosen[role]);
    const shortName = record => {
      if (record.title === 'Default Title') return record.product.title.replace(/\s*(?:\||[-–])\s*(?:Beauty Price Cosmetics|BeautyVes).*$/i, '');
      const name = record.title.replace(/^\d+\s*[-–]\s*/, '').replace(/\d{2,}$/, '').trim();
      return /[A-ZÀ-Ý]/.test(name) && !/[a-zà-ÿ]/.test(name) ? name.charAt(0) + name.slice(1).toLocaleLowerCase() : name;
    };
    const title = record => record.title === 'Default Title' ? record.product.title : `${shortName(record)} · ${record.product.brand === 'bvs' ? 'BeautyVes' : 'Beauty Price Cosmetics'}`;
    const permitted = record => state.brand === 'all' || record.brand === state.brand;
    const applyControls = () => {
      root.setAttribute('aria-busy', String(state.pending || state.committed));
      root.querySelectorAll('button').forEach(button => {
        button.disabled = state.pending || state.committed || (button === add && !selected('base')) || (button.dataset.lipAction === 'back' && state.step === 0);
      });
    };
    const setActiveRole = role => {
      state.activeRole = role;
      root.querySelectorAll('[data-lip-role-tab]').forEach(button => {
        const open = button.dataset.lipRoleTab === role;
        button.setAttribute('aria-expanded', String(open));
      });
      root.querySelectorAll('[data-lip-slot]').forEach(slot => { slot.hidden = slot.dataset.lipSlot !== role; });
    };

    function renderQuiz() {
      const question = QUESTIONS[state.step];
      root.querySelector('[data-lip-step-number]').textContent = String(state.step + 1);
      root.querySelectorAll('[data-lip-orbit]').forEach((orbit, index) => { orbit.classList.toggle('is-current', index === state.step); orbit.classList.toggle('is-done', index < state.step); });
      root.querySelector('[data-lip-question]').textContent = labels[`question_${question.key}`] || '';
      const answers = root.querySelector('[data-lip-answers]');
      answers.replaceChildren();
      question.choices.forEach(choice => {
        const button = element('button', `bp-lip-lab__answer bp-lip-lab__answer--${choice}`);
        button.type = 'button';
        button.dataset.lipAnswer = choice;
        button.setAttribute('aria-pressed', String(state.answers[question.key] === choice));
        if (question.key === 'family') { const swatch = element('span', 'bp-lip-lab__answer-swatch'); button.append(swatch); }
        else button.append(element('span', 'bp-lip-lab__answer-icon', ({ sunset: '◒', star: '✦', daily: '♡', matte: '◕', gloss: '◔', glitter: '✧', natural: '01', defined: '02', bold: '03' })[choice] || '')); 
        button.append(element('strong', '', labels[`answer_${choice}`] || choice));
        if (labels[`answer_${choice}_sub`]) button.append(element('small', '', labels[`answer_${choice}_sub`]));
        answers.append(button);
      });
      applyControls();
    }

    function chooseRecommendation() {
      state.chosen = { liner: null, base: null, finish: null };
      state.activeRole = null;
      const filter = record => permitted(record);
      const basePool = records.filter(record => record.role === 'base' && filter(record));
      const desiredFamily = state.answers.family;
      const matching = basePool.filter(record => record.shade?.family === desiredFamily);
      const moodIndex = state.answers.mood === 'star' ? matching.length - 1 : state.answers.mood === 'sunset' ? Math.floor((matching.length - 1) / 2) : 0;
      const shadeIndex = state.answers.boldness === 'bold' ? matching.length - 1 : state.answers.boldness === 'natural' ? 0 : moodIndex;
      const exactShade = matching[shadeIndex];
      const base = exactShade || basePool[0];
      if (base) state.chosen.base = base.id;
      const linerPool = records.filter(record => record.role === 'liner' && filter(record));
      const baseName = base?.title.replace(/^\d+\s*[-–]\s*/, '').trim().toLocaleLowerCase();
      const liner = linerPool.find(record => baseName && record.title.toLocaleLowerCase().includes(baseName)) || linerPool.find(record => record.shade?.family === base?.shade?.family) || linerPool[0];
      state.chosen.liner = state.answers.boldness === 'natural' ? null : (liner?.id || null);
      let finishPool = records.filter(record => record.role === 'finish' && filter(record));
      if (state.answers.finish === 'glitter') finishPool = finishPool.filter(record => record.shade?.family === 'glitter');
      if (state.answers.finish === 'matte') finishPool = [];
      if (state.answers.finish === 'gloss') finishPool = finishPool.filter(record => record.shade?.family !== 'glitter');
      state.chosen.finish = finishPool[0]?.id || null;
      reason.textContent = `${exactShade ? labels.recommendation : labels.recommendation_brand}${state.answers.finish !== 'matte' && !finishPool.length ? ` ${labels.finishUnavailable}` : ''}`;
      reason.hidden = false;
    }

    function renderOptions(role) {
      const container = root.querySelector(`[data-lip-options="${role}"]`);
      container.replaceChildren();
      const options = records.filter(record => record.role === role && permitted(record));
      if (role !== 'base') {
        const clear = element('button', 'bp-lip-lab__option bp-lip-lab__option--clear', labels.clear);
        clear.type = 'button'; clear.dataset.lipChoice = ''; clear.dataset.lipRole = role;
        clear.setAttribute('aria-pressed', String(state.chosen[role] === null));
        container.append(clear);
      }
      if (!options.length) {
        container.append(element('p', 'bp-lip-lab__empty', role === 'liner' && state.brand === 'bpc' ? labels.noLiner : labels.noOptions));
        return;
      }
      options.forEach(record => {
        const button = element('button', 'bp-lip-lab__option');
        button.type = 'button'; button.dataset.lipChoice = record.id; button.dataset.lipRole = role;
        button.setAttribute('aria-pressed', String(state.chosen[role] === record.id));
        const visual = element('span', 'bp-lip-lab__option-visual');
        if (record.swatch || record.image) {
          const img = document.createElement('img'); img.src = record.swatch || record.image; img.alt = ''; img.loading = 'lazy'; img.width = 64; img.height = 64; visual.append(img);
        } else if (record.shade?.color) visual.style.backgroundColor = record.shade.color;
        button.append(visual);
        const copy = element('span', 'bp-lip-lab__option-copy');
        copy.append(element('strong', '', shortName(record)));
        copy.append(element('small', '', `${record.brand === 'bvs' ? 'BeautyVes' : 'Beauty Price Cosmetics'} · ${format(record.price, catalog.currency, catalog.language)}`));
        button.append(copy);
        container.append(button);
      });
    }

    function renderVisual() {
      const base = selected('base');
      const liner = selected('liner');
      const finish = selected('finish');
      renderer?.update({ base, liner, finish: finish ? { ...finish, ...(FINISH[finish.id] || { tint: null, tintOpacity: 0, sheen: .24, glitter: 0 }) } : null });
      rendererHost?.setAttribute('aria-label', `${labels.previewText}${base ? `: ${title(base)}` : ''}`);
      const warning = root.querySelector('[data-lip-preview-unknown]');
      if (warning) warning.hidden = !base || (Boolean(base.shade?.color) && (!liner || Boolean(liner.shade?.color)));
    }

    function renderSummary() {
      summary.replaceChildren();
      let cents = 0;
      ['liner', 'base', 'finish'].forEach(role => {
        const record = selected(role);
        const row = element('div', 'bp-lip-lab__summary-row');
        row.append(element('span', '', labels[role]));
        if (record) {
          cents += Number(record.price) || 0;
          const link = element('a', '', title(record));
          link.href = `${record.product.url}?variant=${encodeURIComponent(record.id)}`;
          row.append(link);
          row.append(element('strong', '', format(record.price, catalog.currency, catalog.language)));
        } else row.append(element('span', 'bp-lip-lab__summary-empty', role === 'base' ? labels.choose : labels.optional));
        summary.append(row);
      });
      total.textContent = selected('base') ? format(cents, catalog.currency, catalog.language) : '—';
      add.textContent = state.pending ? labels.adding : labels.add;
      root.querySelectorAll('[data-lip-slot-summary]').forEach(slot => {
        const role = slot.dataset.lipSlotSummary;
        const record = selected(role);
        slot.textContent = record ? shortName(record) : role === 'base' ? labels.choose : labels.optional;
      });
      const revealName = root.querySelector('[data-lip-reveal-name]');
      if (revealName) revealName.textContent = labels[`reveal_${state.answers.mood}`] || labels.revealDefault;
      const revealPieces = root.querySelector('[data-lip-reveal-pieces]');
      if (revealPieces) {
        revealPieces.replaceChildren();
        ['base', 'liner', 'finish'].forEach(role => {
          const record = selected(role);
          if (record) revealPieces.append(element('span', 'bp-lip-lab__reveal-piece', `${labels[role]} · ${shortName(record)}`));
        });
      }
      renderVisual();
      applyControls();
    }

    function renderComposer() {
      root.querySelectorAll('[data-lip-brand]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lipBrand === state.brand)));
      ['liner', 'base', 'finish'].forEach(renderOptions);
      setActiveRole(state.activeRole);
      renderSummary();
    }

    function mode(name) {
      state.mode = name;
      root.dataset.lipMode = name;
      work.hidden = name === 'intro';
      quiz.hidden = name !== 'quiz';
      reveal.hidden = name !== 'reveal';
      composer.hidden = name !== 'compose';
      resultPanel.hidden = name === 'quiz';
      summaryPanel.hidden = name === 'quiz';
      if (name === 'quiz') renderQuiz();
      if (name === 'reveal') renderSummary();
      if (name === 'compose') { if (state.activeRole === null) state.activeRole = 'base'; renderComposer(); }
      if (name !== 'intro') work.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      if (name === 'quiz') root.querySelector('[data-lip-question]').focus({ preventScroll: true });
      if (name === 'reveal') root.querySelector('[data-lip-reveal-heading]').focus({ preventScroll: true });
      if (name === 'compose') root.querySelector('[data-lip-composer-heading]').focus({ preventScroll: true });
    }

    async function addCombo() {
      if (state.pending || state.committed || state.destroyed) return;
      const recordsToAdd = ['liner', 'base', 'finish'].map(selected).filter(Boolean);
      if (!selected('base')) { setStatus(labels.selectBase, true); return; }
      state.pending = true; renderSummary(); setStatus('');
      let phase = 'read';
      const timedPhase = async (request, limit) => {
        const controller = new AbortController();
        state.request = controller;
        const timeoutId = window.setTimeout(() => controller.abort(), limit);
        try { return await request(controller.signal); }
        finally { window.clearTimeout(timeoutId); if (state.request === controller) state.request = null; }
      };
      try {
        const uniqueHandles = [...new Set(recordsToAdd.map(record => record.product.handle))];
        const freshProducts = await timedPhase(signal => Promise.all(uniqueHandles.map(async handle => {
          const response = await fetch(`${normalizedRoot(catalog.root)}products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin', cache: 'no-store', signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('availability');
          return [handle, await response.json()];
        })), 15000);
        const byHandle = new Map(freshProducts);
        let changed = false;
        for (const record of recordsToAdd) {
          const current = byHandle.get(record.product.handle)?.variants?.find(variant => String(variant.id) === record.id);
          if (!current || !current.available || !Number.isSafeInteger(Number(current.price)) || Number(current.price) < 0) throw new Error('availability');
          if (Number(current.price) !== Number(record.price)) { record.price = Number(current.price); changed = true; }
        }
        if (changed) { renderComposer(); setStatus(labels.changed, true); return; }
        if (state.destroyed) return;
        const items = [...new Map(recordsToAdd.map(record => [record.id, { id: Number(record.id), quantity: 1 }])).values()];
        phase = 'write';
        const response = await timedPhase(signal => fetch(`${normalizedRoot(catalog.root)}cart/add.js`, {
          method: 'POST', credentials: 'same-origin',
          signal,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items })
        }), 20000);
        if (!response.ok) {
          setStatus(response.status === 422 ? labels.stockError : labels.cartError, true, true);
          return;
        }
        state.committed = true;
        if (state.destroyed) return;
        const launch = window.BPLaunch;
        if (launch) {
          phase = 'sync';
          await launch.ready;
          const launchState = launch.state?.();
          if (launchState?.active || launchState?.ended) {
            if (typeof window.BPLaunchCart?.sync !== 'function') throw new Error('Launch cart sync unavailable');
            await window.BPLaunchCart.sync();
          }
        }
        window.location.assign(`${normalizedRoot(catalog.root)}cart`);
      } catch (error) {
        if (!state.destroyed) {
          if (state.committed) setStatus(labels.syncError, true, true);
          else setStatus(error.message === 'availability' ? labels.unavailable : (phase === 'write' ? labels.networkError : labels.readError), true, phase === 'write');
        }
      } finally {
        state.pending = false; state.request = null;
        if (!state.destroyed) renderSummary();
      }
    }

    listen(root, 'click', event => {
      if (state.pending || state.committed || state.destroyed) return;
      const answer = event.target.closest('[data-lip-answer]');
      if (answer && root.contains(answer)) {
        state.answers[QUESTIONS[state.step].key] = answer.dataset.lipAnswer;
        if (state.step < QUESTIONS.length - 1) { state.step += 1; renderQuiz(); root.querySelector('[data-lip-question]').focus({ preventScroll: true }); }
        else { chooseRecommendation(); mode('reveal'); }
        return;
      }
      const roleTab = event.target.closest('[data-lip-role-tab]');
      if (roleTab && root.contains(roleTab)) { setActiveRole(state.activeRole === roleTab.dataset.lipRoleTab ? null : roleTab.dataset.lipRoleTab); return; }
      const brand = event.target.closest('[data-lip-brand]');
      if (brand && root.contains(brand)) {
        state.brand = brand.dataset.lipBrand;
        ['liner', 'base', 'finish'].forEach(role => { if (selected(role) && !permitted(selected(role))) state.chosen[role] = null; });
        reason.hidden = true; renderComposer(); setStatus(''); return;
      }
      const choice = event.target.closest('[data-lip-choice]');
      if (choice && root.contains(choice)) {
        const role = choice.dataset.lipRole;
        const id = choice.dataset.lipChoice;
        state.chosen[role] = id || null;
        reason.hidden = true;
        state.activeRole = null;
        renderComposer(); setStatus('');
        root.querySelector(`[data-lip-role-tab="${role}"]`)?.focus({ preventScroll: true });
        return;
      }
      const action = event.target.closest('[data-lip-action]');
      if (!action || !root.contains(action)) return;
      switch (action.dataset.lipAction) {
        case 'quiz': state.step = 0; state.answers = {}; mode('quiz'); break;
        case 'compose': mode('compose'); break;
        case 'reveal': mode('reveal'); break;
        case 'back': if (state.step > 0) { state.step -= 1; renderQuiz(); root.querySelector('[data-lip-question]').focus({ preventScroll: true }); } break;
        case 'restart': state.chosen = { liner: null, base: null, finish: null }; state.brand = 'all'; state.activeRole = null; state.step = 0; state.answers = {}; reason.hidden = true; setStatus(''); mode('quiz'); break;
        case 'add': addCombo(); break;
      }
    });
    const cleanup = () => {
      state.destroyed = true;
      state.request?.abort();
      if (stickyFrame) window.cancelAnimationFrame(stickyFrame);
      headerResize?.disconnect();
      headerMutation?.disconnect();
      renderer?.destroy();
      listeners.forEach(([target, type, fn]) => target.removeEventListener(type, fn));
      root.style.removeProperty('--bp-lip-sticky-top');
      instances.delete(root);
    };
    instances.set(root, cleanup);
    renderSummary();
  }

  const roots = scope => [
    ...(scope.matches?.('[data-bp-lip-lab]') ? [scope] : []),
    ...scope.querySelectorAll?.('[data-bp-lip-lab]') || []
  ];
  const api = {
    initialize(scope = document) { roots(scope).forEach(mount); },
    destroy(scope = document) { roots(scope).forEach(root => instances.get(root)?.()); }
  };
  window.BPLipLabAPI = api;
  api.initialize(document);
  document.addEventListener('shopify:section:load', event => api.initialize(event.target));
  document.addEventListener('shopify:section:unload', event => api.destroy(event.target));
})();
